import { resolveMaintenanceRedirect, isMaintenanceExemptPath } from "@/features/maintenance/utils/resolve-maintenance-redirect";
import { useMaintenance } from "@/providers/MaintenanceProvider";
import { FCC } from "@/types/common";
import { CircularProgress, Stack } from "@mui/material";
import { Navigate, useLocation } from "react-router-dom";

export const MaintenanceGuard: FCC = ({ children }) => {
  const { data, isLoading } = useMaintenance();
  const { pathname } = useLocation();

  // Error/404 pages must render even while (or if) the maintenance lookup fails,
  // since they are what the user sees when the backend is unreachable.
  if (isMaintenanceExemptPath(pathname)) return <>{children}</>;

  if (isLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" height="100vh">
        <CircularProgress />
      </Stack>
    );
  }

  const redirectTo = resolveMaintenanceRedirect(data, pathname);
  if (redirectTo) return <Navigate to={redirectTo} replace />;

  return <>{children}</>;
};
